
import { SparklesIcon, UserIcon } from "@heroicons/react/20/solid";
import React, { useEffect, useState } from "react";
import { Button } from "./catalyst/button";

interface ProfileData {
  qfsin?: string;
  identity?: {
    fullName?: string;
    givenName?: string;
    familyName?: string;
    pronoun?: string;
    nicknames?: string[] | null;
  };
  birth?: {
    date?: string;
    time?: string;
    place?: string;
  };
  traits?: {
    dominantHand?: string | null;
    spiritualOrientation?: string | null;
  };
  current?: {
    residence?: string;
  };
  relatedPerson: ProfileData
  mathLogic?: any;
  mathCalculation?: any
}

type ProfileSectionProps =
  | {
      title: string;
      profile: ProfileData | undefined;
      mathData?: any;
      dark?: boolean;
      showMath: boolean;
      showRelatedPersonButton?: false;
      onRelatedPersonClick?: never; // ❌ forbidden
    }
  | {
      title: string;
      profile: ProfileData | undefined;
      mathData?: any;
      dark?: boolean;
      showMath: boolean;
      showRelatedPersonButton: true;
      onRelatedPersonClick: () => void; // ✅ required
    };


function ProfileSection(props: ProfileSectionProps) {
  const {
    title,
    profile,
    mathData,
    dark = false,
    showMath,
    showRelatedPersonButton,
  } = props;
  const [showMathSection, setShowMathSection] = useState(false);
  if (!profile) return null;
 

  const containerClass = dark
    ? "bg-dark-background-secondary-medium border-zinc-700 text-zinc-100"
    : (showRelatedPersonButton ? "bg-white border-zinc-200 text-zinc-800": "bg-zinc-50 border-zinc-200 text-zinc-800");

  const headingClass = dark ? "text-dark-text" : "text-zinc-700";
  const iconClass = dark ? "text-dark-text" : "text-zinc-500";

  const fullName =
    profile.identity?.fullName ||
    `${profile.identity?.givenName || ""} ${profile.identity?.familyName || ""}`.trim() ||
    "—";

  const formattedBirth =
    profile.birth?.date
      ? new Date(profile.birth.date).toLocaleDateString("en-IN", {
        timeZone: "UTC",
        day: "2-digit",
        month: "short",
        year: "numeric",
        })
      : "—";

      
  
  const qfsin = mathData?.qfsin?.value || "—";

  function extractUserDataFromMath(mathematicalData:any) {
    const result: Record<string, any> = {};
  
    if (!mathematicalData || Object.keys(mathematicalData).length === 0) {
      return result;
    }
  
    console.log("mathData", mathData)
    const {
      chaldeanTotal,
      compositeRarity,
      dobCal,
      fullName,
      harmonicTeslaIndex,
      hiddenTeslaPotential,
      initials,
      seqTeslaPresence,
      totemAnimalAndzodiac,
      primaryGeometry,
      primaryArchetype,
      primaryPolarity,
      multistateCycle,
      elementalCode,
      polarityLessonFrame,
      shadow
    } = mathematicalData;
  
    const assignIfExists = (key: string, value: any) => {
      if (value !== undefined && value !== null) {
        result[key] = value;
      }
    };

    //
    assignIfExists("Life path number", (mathData.dobCal?.dobIsMaster
      ? mathData.dobCal?.dobMasterNumber?.value
      : mathData.decimalRoot?.decimalRootIs))
    
    console.log("hererere--------------->", mathData)
    assignIfExists("Life path calculation text", dobCal?.lifePathCalculationText?.value)
    assignIfExists("lifePathKeyword", dobCal?.lifePathKeyword?.value)
      
    
    // Life Path
    assignIfExists("lifePathFrequency", dobCal?.lifePathFrequency?.value);
    assignIfExists("Rarity Score", dobCal?.lifePathRarity?.value);
  
    // Full Name
    assignIfExists("Name vibration number", fullName?.nameVibrationNumber?.value);
    assignIfExists("Does the full name reduce to a master number?", fullName?.fullNameString?.value);
    
    assignIfExists("Name vibration keyword", mathData?.nameVibrationKeyword?.value);
    assignIfExists("Name frequency (hz)", mathData?.nameFrequencyHz?.value);
    assignIfExists("Name frequency keyword", mathData?.nameFrequencyHzKeyword?.value);
   
    
    assignIfExists("Initials frequency (hz)", mathData?.initialsFrequencyHz?.value);
    
    assignIfExists("nameVibrationFrequency", fullName?.nameVibrationFrequency?.value);
    assignIfExists("nameVibrationRarity", fullName?.nameVibrationRarity?.value);
    assignIfExists("harmonicTeslaIndex", harmonicTeslaIndex?.value);
    assignIfExists("Hidden Tesla Potential", hiddenTeslaPotential?.htp?.value);
    assignIfExists("Description for Hidden Tesla Potential",hiddenTeslaPotential?.desc?.value);
  
    // Initials
    assignIfExists("initialsRoot", initials?.initialsRoot?.value);
    assignIfExists("Initials vibration calculation", initials?.initialsVibrationCalculation?.value);
    assignIfExists("Do the initials reduce to a master number ?", initials?.initialsString?.value);
    assignIfExists("initialsFrequency", initials?.initialsFrequency?.value);
    assignIfExists("initialsRarity", initials?.initialsRarity?.value);
  
    // General
    assignIfExists("compositeRarity", compositeRarity?.value);
    assignIfExists("Reduction-Sequence Tesla Check", seqTeslaPresence?.value);
    assignIfExists("chaldeanTotal", chaldeanTotal?.value);
    
  
    // Totem & Zodiac
    assignIfExists("totemList", mathData?.totems?.value);
    assignIfExists("spiritAnimal", totemAnimalAndzodiac?.spiritAnimal?.value);
    assignIfExists("zodiac", totemAnimalAndzodiac?.zodiac?.value);
    assignIfExists(
      "correspondingTraits",
      totemAnimalAndzodiac?.correspondingTraits?.value
    );
  
    // Primary Archetype
    assignIfExists("primaryArchetype",primaryArchetype?.archetypePrimary?.value);

    assignIfExists("Archetype modifiers",
      Array.isArray(primaryArchetype?.archetypeMythicTriad?.value)
        ? primaryArchetype.archetypeMythicTriad.value.join(", ")
        : primaryArchetype?.archetypeMythicTriad?.value
    );


    // Primary Geometry
    assignIfExists("lifePathGeometry",primaryGeometry?.lifePathGeometry?.value);
    assignIfExists("nameGeometry",primaryGeometry?.nameGeometry?.value);
    assignIfExists("initialsGeometry",primaryGeometry?.initialsGeometry?.value);
    assignIfExists("primaryGeometry",primaryGeometry?.geometryPrimary?.value);


    // shadow theme
    assignIfExists("Shadow theme", shadow?.shadowTheme?.value);
    assignIfExists("Shadow light", shadow?.shadowLight?.value);
    assignIfExists("Shadow dark", shadow?.shadowDark?.value);


    // polarity 
    assignIfExists("Primary polarity", primaryPolarity?.value);
    assignIfExists(
      "Polarity lesson frame",
      polarityLessonFrame?.lessonFrame?.value
    );
    
    assignIfExists(
      "Polarity lesson",
      polarityLessonFrame?.polarityLesson?.value
    );
    

    // Cycle and timings
    assignIfExists("Polarity ratio", mathData?.polarityRatio?.value);
    assignIfExists("Current cycle group", multistateCycle?.cycleGroup?.value);
    assignIfExists("Current cycle label", multistateCycle?.cycleLabel?.value);
    assignIfExists("Current cycle theme", multistateCycle?.cycleTheme?.value);
    assignIfExists("Current cycle description", multistateCycle?.cycleDescription?.value);
    assignIfExists("Current gate", multistateCycle?.gateName?.value);

    // elemental code
    assignIfExists("Elemental code", elementalCode?.value);

    console.log("result", result)
    return result;
  }
  function formatLabel(key: string) {
    return key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (c) => c.toUpperCase());
  }
  const mathListData = extractUserDataFromMath(mathData)
  const mathListArray = Object.entries(mathListData).map(([key, value]) => ({
    label: formatLabel(key),
    value,
  }));
  console.log("listArray---", mathListArray)

  return (
    <div>
      <div className={`${containerClass} rounded-lg border p-4 shadow-sm mb-4`}>
            <h3 className={`mb-3 text-sm font-medium flex items-center gap-2 ${headingClass}`}>
              <UserIcon className={`h-5 w-5 ${iconClass}`} />
              {title}
            </h3>

            <div className="space-y-2 text-sm">
              <Detail label="QFSIN" value={qfsin} dark={dark} />
              <Detail label="Subject" value={fullName} dark={dark} />
              <Detail label="Date of Birth" value={formattedBirth} dark={dark} />
              <Detail label="Place of birth" value={profile.birth?.place || "—"} dark={dark} />
              <Detail label="Dominant hand" value={profile.traits?.dominantHand || "—"} dark={dark} />
              <Detail label="Spiritual Orientation" value={profile.traits?.spiritualOrientation || "—"} dark={dark} />
              <Detail
                label="Nicknames"
                value={profile.identity?.nicknames?.join(", ") || "—"}
                dark={dark}
              />
              <Detail label="Current residence" value={profile.current?.residence || "—"} dark={dark} />
            </div>
            {"showRelatedPersonButton" in props && props.showRelatedPersonButton && (
            <div className="pt-2 flex justify-end">
              <Button
                color="soft"
                className="text-sm"
                onClick={props.onRelatedPersonClick}
              >
                See related persons
              </Button>
  </div>
)}

        </div>

        {(mathData &&showMath) && (
  <div className={`${containerClass} rounded-lg border p-4 shadow-sm mb-4`}>
    
    {/* Header Clickable Toggle */}
    <div
      className="flex items-center justify-between cursor-pointer select-none"
      onClick={() => setShowMathSection(!showMathSection)}
    >
      <h3 className={`text-sm font-medium flex items-center gap-2 ${headingClass}`}>
        <SparklesIcon className={`h-5 w-5 ${iconClass}`} />
        Calculated values
      </h3>

      {/* Arrow icon rotates */}
      <svg
        className={`h-5 w-5 transition-transform duration-300 ${
          showMathSection ? "rotate-180" : "rotate-0"
        } ${iconClass}`}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path d="M19 9l-7 7-7-7" />
      </svg>
    </div>

    {/* Collapsible Content */}
    <div
      className={`overflow-hidden transition-all duration-300 ${
        showMathSection ? " mt-3 " : "max-h-0 "
      }`}
    >
      <div className="space-y-2 text-sm">
        {mathListArray.map((item: any, index: number) => (
          <ListItems
            key={index}
            label={item.label}
            value={item.value}
            dark={dark}
          />
        ))}
      </div>
    </div>

  </div>
)}

    </div>
    
  );
}
function Detail({ label, value, dark = false }: { label: string; value: string; dark?: boolean }) {
  const labelClass = dark ? "text-zinc-400" : "text-zinc-500";
  const valueClass = dark ? "text-zinc-100" : "text-zinc-800";

  return (
    <div>
      <div className={`text-xs ${labelClass}`}>{label}</div>
      <div className={valueClass}>{value || "—"}</div>
    </div>
  );
}

function ListItems({
  label,
  value,
  dark = false,
}: {
  label: string;
  value: string;
  dark?: boolean;
}) {
  const labelClass = dark ? "text-zinc-400" : "text-zinc-500";
  const valueClass = dark ? "text-zinc-100" : "text-zinc-900";

  return (
    <div className="grid grid-cols-[40%_60%] gap-4 text-xs py-3 border-b border-zinc-300">
      <div className={`${labelClass} font-medium`}>
        {label}
      </div>

      <div className={`${valueClass} leading-relaxed break-words`}>
        {value || "—"}
      </div>
    </div>
  );
}


type MemberDetailsCardProps =
  | {
      data: {
        profile: ProfileData;
        mathCalculation: { qfsin: { value: string } };
        mathLogic?: any;
      };
      dark?: boolean;
      showMath?: boolean;
      showRelatedPersonButton?: false;
      onRelatedPersonClick?: never;
    }
  | {
      data: {
        profile: ProfileData;
        mathCalculation: { qfsin: { value: string } };
        mathLogic?: any;
      };
      dark?: boolean;
      showMath?: boolean;
      showRelatedPersonButton: true;
      onRelatedPersonClick: () => void;
    };

    export default function MemberDetailsCard(props: MemberDetailsCardProps) {
      const {
        data,
        dark = false,
        showMath = false,
      } = props;
    
      if (!data) {
        return (
          <div className="rounded-lg border p-4 shadow-sm text-sm opacity-80">
            No profile data available.
          </div>
        );
      }
    
      const mainProfile = data.profile;
      const relatedProfile = data.profile?.relatedPerson;
    
      return (
        <div>
          {/* MAIN PROFILE */}
          {"showRelatedPersonButton" in props && props.showRelatedPersonButton ? (
            <ProfileSection
              title="Member Details"
              profile={mainProfile}
              mathData={data.mathCalculation || data.mathLogic}
              dark={dark}
              showMath={showMath}
              showRelatedPersonButton={true}
              onRelatedPersonClick={props.onRelatedPersonClick}
            />
          ) : (
            <ProfileSection
              title="Member Details"
              profile={mainProfile}
              mathData={data.mathCalculation || data.mathLogic}
              dark={dark}
              showMath={showMath}
            />
          )}
    
          {/* RELATED PROFILE */}
          {relatedProfile && (
            <ProfileSection
              title="Related Person"
              profile={relatedProfile}
              mathData={relatedProfile.mathCalculation || relatedProfile.mathLogic}
              dark={dark}
              showMath={showMath}
            />
          )}
        </div>
      );
    }
    
    

